import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

/**
 * Turkish-locale formatted money input.
 * - Displays with `.` thousand separators and `,` decimal (tr-TR).
 * - Accepts free typing (digits, comma, dot).
 * - Emits a plain Number via onChange.
 */

function formatTR(n) {
  if (n === "" || n === null || n === undefined) return "";
  const num = Number(n);
  if (isNaN(num)) return "";
  return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(num);
}

export function parseTRNumber(str) {
  if (str === "" || str === null || str === undefined) return 0;
  const cleaned = String(str).replace(/\s/g, "").replace(/\./g, "").replace(",", ".");
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
}

export default function MoneyInput({ value, onChange, ...rest }) {
  const [display, setDisplay] = useState(() => (value ? formatTR(value) : ""));

  // Reconcile display when parent value changes externally (form resets etc.)
  useEffect(() => {
    const parsed = parseTRNumber(display);
    if (Number(value || 0) !== parsed) {
      setDisplay(value === 0 || value === "" || value === null || value === undefined ? "" : formatTR(value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (e) => {
    // Keep raw text as user types (digits, dots, commas). Filter out other chars.
    const raw = e.target.value.replace(/[^\d.,]/g, "");
    setDisplay(raw);
    onChange?.(parseTRNumber(raw));
  };

  const handleBlur = () => {
    // Pretty-format on blur for consistency
    const n = parseTRNumber(display);
    setDisplay(n ? formatTR(n) : "");
  };

  return (
    <Input
      {...rest}
      type="text"
      inputMode="decimal"
      value={display}
      onChange={handleChange}
      onBlur={handleBlur}
      dir="ltr"
    />
  );
}
